export const API_URL =
    process.env.REACT_APP_API_URL ||
    "https://backend-nexus-project.up.railway.app";

export const BOT_API_URL =
    process.env.REACT_APP_BOT_API_URL ||
    "https://bot-discord-nexus-production.up.railway.app";
